//Sirve para implementar el geobloqueo de la creación de cuentas
export const ALLOWED_COUNTRIES = ['AR', 'BZ', 'BO', 'CL', 'CO', 'CR', 'DO', 'EC', 'SV', 'GT', 'HN', 'MX', 'NI', 'PA', 'PY', 'PE', 'UY', 'VE']; //Paises en los que esta disponible

export const checkGeo = (country?: string) => {
  //console.log(`checkGeo fue llamado con country: ${country}`); // log de depuración  para ver que entro a la funcion
  if (!country) {
    throw new Error('Your location could not be determined. Account creation is restricted in your region.');
  } //mensaje que arroja si su ubicación no puede ser detectada

  if (!ALLOWED_COUNTRIES.includes(country.toUpperCase())) {
    throw new Error('Account creation is not available in your country.');
  } //Mensaje que arroja si no esta en un país permitido
  //console.log(`Cuenta permitida para country: ${country}`); // log si es permitido, para ver si la funcion funciona
};
